/**
 * Permission identifiers for the complaint / dispute work order module.
 *
 * Mirrors apps/api/src/auth/services/module-catalog.ts so frontend gating
 * cannot diverge from backend RBAC.
 */
import { hasAnyPermission, hasPermission } from './crmPermissions';

export { hasAnyPermission, hasPermission };

export const COMPLAINT_PERMISSIONS = {
  READ: 'complaints:read',
  CREATE: 'complaints:create',
  TRANSITION: 'complaints:transition',
  ESCALATE: 'complaints:escalate',
  REVIEW: 'complaints:review',
  CLOSE: 'complaints:close',
} as const;

export function canSeeComplaintMenu(
  permissions: readonly string[],
): boolean {
  return hasPermission(permissions, COMPLAINT_PERMISSIONS.READ);
}
